import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  timeout: 5000, // set the default timeout for requests to 5 seconds
});

const getCurrentLanguage = () => localStorage.getItem("language") || "10";

instance.interceptors.request.use(
  function (config) {
    let currency = JSON.parse(localStorage.getItem("currency"));

    if (!currency) {
      currency = { code: "EUR", symbol: "€" };
    }

    const lang_id = getCurrentLanguage();
    if (config.method === "get") {
      config.params = {
        ...config.params,
        lang_id,
        currency: currency.code,
      };

      config.params["lang_id"] = lang_id;
    } else if (
      ["post", "put", "patch", "POST", "PUT", "PATCH"].includes(config.method)
    ) {
      if (config.data instanceof FormData) {
        config.data.append("currency", currency.code);
      } else {
        config.data = {
          ...config.data,
          currency: currency.code,
          lang_id,
        };
      }
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default instance;
